var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseThin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E8568D61-FE74-4C0E-BC24-CF19F96FA5C4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Quiz",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/Header",
    transform: "translate(-16.000000, -16.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 360,
    height: 56
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/20/Neutral/N100/Help",
    transform: "translate(16.000000, 16.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.63058531,4.83578805 L5.64774759,4.85225246 L11.9995,11.2035 L18.3522525,4.85225246 C18.5719224,4.63258254 18.9280777,4.63258254 19.1477477,4.85225246 C19.361785,5.06628981 19.3672732,5.40990304 19.1642121,5.63058531 L19.1477477,5.64774759 L12.7955,11.9995 L19.1477477,18.3522525 C19.3674176,18.5719224 19.3674176,18.9280777 19.1477477,19.1477477 C18.9337103,19.361785 18.5900971,19.3672732 18.3694148,19.1642121 L18.3522525,19.1477477 L11.9995,12.7955 L5.64774759,19.1477477 C5.42807768,19.3674176 5.07192238,19.3674176 4.85225246,19.1477477 C4.63821511,18.9337103 4.63272697,18.5900971 4.83578805,18.3694148 L4.85225246,18.3522525 L11.2035,11.9995 L4.85225246,5.64774759 C4.63258254,5.42807768 4.63258254,5.07192238 4.85225246,4.85225246 C5.06628981,4.63821511 5.40990304,4.63272697 5.63058531,4.83578805 Z",
    id: "Combined-Shape"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseThin);
export default __webpack_public_path__ + "static/media/close-thin.cbca6990.svg";
export { ForwardRef as ReactComponent };